// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","icon":"inlineIcon-module__icon___Dbeb_","link":"inlineIcon-module__link___2_227"};